<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 20:06:36
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-12 13:59:02

四种状态
 * @success
 * @danger
 * @warning
 * @default
--> 
<template>
	<div>
		<div v-if="row.other_status !== 200 && (tabName == '0' || tabName == '1')">
			<p v-if="row.other_status === 300 || row.other_status === 201 || row.other_status === 202" class="font-h6-regular flex-row-align-center">
				<i :class="{ warning: row.other_status === 300, danger: row.other_status === 201, defa: row.other_status === 202, round: true }"></i>
				<span class="ml-4">{{ row.other_status_desc }}</span>
			</p>
			<div class="flex-row-align-center" v-else>
				<i :class="{ success: row.other_status === 600, danger: row.other_status === 400, warning: row.other_status === 401, round: true }"></i>
				<p class="ml-4">{{ row.other_status_desc }}</p>
			</div>
		</div>
		<div v-if="tabName == '2'">
			<div class="flex-row-align-center">
				<i
					:class="{
						warning: (row.url_check_status == linkStatus.toboUp || row.url_check_status == linkStatus.tobeCheck) && row.cooperate_status !== '3',
						default: row.cooperate_status == '3',
						success: row.url_check_status == linkStatus.finished,
						round: true,
					}"
				></i>
				<p class="ml-4">{{ row.cooperate_status == '3' ? row.cooperate_status_desc : row.url_check_status_desc }}</p>
			</div>
		</div>
		<div class="flex-row-align-center" v-if="tabName == '3'">
			<i :class="{ success: row.cooperate_status == '1', default: row.cooperate_status == '2', round: true }"></i>
			<p class="ml-4">{{ row.cooperate_status_desc }}</p>
		</div>
	</div>
</template>

<script>
import { linkStatus } from '@/utils/dataMap';

export default {
	props: {
		btnText: {
			type: String,
			default: () => '',
		},
		tabName: {
			type: String,
			default: () => '0',
		},
		row: {
			type: Object,
			default: () => {},
		},
	},
	name: 'btnState',
	data() {
		return {
			linkStatus,
		};
	},
	computed: {},
	methods: {},
};
</script>

<style lang="less" scoped>
.btnStyle {
	padding: 4px 8px;
	border-radius: 15px;
}
.round {
	display: inline-block;
	width: 6px;
	height: 6px;
	border-radius: 3px;
}
.success {
	background-color: @color-success;
}
.warning {
	background-color: @color-warning;
}
.danger {
	background-color: @color-danger;
}
.default {
	background-color: @color-info;
}
</style>
